import Login from "../components/login-form/Login";
import ResetPassword from "../components/login-form/ResetPassword";
import ChangePassword from "../components/login-form/ChangePassword";
import ForgotPassword from "../components/login-form/ForgotPasswordForm";
import SuperAdmin from "../components/super-admin/index";
import Analytics from "../components/dashboard/analytics.jsx";
import Configurations from "../components/configurations/configuration.jsx";
import OrganisationList from "../components/organisation-list/organisation-list.jsx";
import EditPartner from "../components/super-admin/editPartner.jsx";
import AddPartnerForm from "../components/super-admin/addNewPartner.jsx";
import AddHelp from "../components/super-admin/help/addHelp.jsx";
import EditHelp from "../components/super-admin/help/editHelp.jsx";

const protectedRoutes = [
  // {
  //     path: "",
  //     component: <MicrositeLists />,
  //     exact: true,
  // },
  {
    path: "admin",
    component: <SuperAdmin />,
    exact: true,
  },
  //   {
  //     path: "edit-microsite/*",
  //     component: <Edit />,
  //     exact: true,
  //   },
  //   {
  //     path: "edit-organization",
  //     component: <EditOrganization />,
  //     exact: true,
  //   },
  {
    path: "change-password",
    component: <ChangePassword />,
    exact: true,
  },
  {
    path: "dashboard/:partnerId",
    component: <Analytics />,
    exact: true,
  },
  {
    path: "configuration/:partnerId",
    component: <Configurations />,
    exact: true,
  },
  {
    path: "organisation-list/:partnerId",
    component: <OrganisationList />,
    exact: true,
  },
  {
    path: "edit-partner/:partnerId",
    component: <EditPartner />,
    exact: true,
  },
  {
    path: "add-partner",
    component: <AddPartnerForm />,
    exact: true,
  },
  {
    path: "add-help",
    component: <AddHelp />,
    exact: true,
  },
  {
    path: "edit-help/:id",
    component: <EditHelp />,
    exact: true,
  },

  //   {
  //     path: "help",
  //     component: <Help />,
  //     exact: true,
  //   }
];

const publicRoutes = [
  {
    // When route is changed, change it in the navigate tag in protected-routes.jsx
    // path: "login/Hampshire_Chamber_of_Commerce",
    path: "SuperAdmin",
    component: <Login />,
    exact: true,
  },
  {
    path: "forgot-password",
    component: <ForgotPassword />,
    exact: true,
  },
  {
    path: "reset-password/:token",
    component: <ResetPassword />,
    exact: true,
  },
];

export { protectedRoutes, publicRoutes };
